<div class="graph-wrapper">
    <div class="header">
        <h4 class="ellipses d-flex">Delivered Quantity ({{data?.unit}}) vs Cost% &nbsp;
            <div [popover]="popTemplate" triggers="mouseenter:mouseleave" container="body" placement="bottom"><img
                    src="../../../assets/images/icn-info.svg" alt=""></div>
        </h4>
        <div class="minimise" mat-dialog-close></div>
    </div>
    <div #graphDiv width="100%" height="100%" class="bar-chart" id="graphDiv"></div>
</div>
<ng-template #popTemplate>
    <div class="mb-15">Daily/Monthly trend of Delivered Quantity against Cost % at the
        Factory level</div>

    <div class="tooltip-formula">
        <div class="tooltip-left">
            Cost % =
        </div>
        <div class="tooltip-center">
            <div class="tooltip-center-top">
                total waste cost generated on a day/month

            </div>
            <hr class="tooltip-center-middle">
            <div class="tooltip-center-bottom">
                total waste cost of the factory for the selected period
            </div>

        </div>
        <div class="tooltip-right">
            * 100
        </div>
    </div>

</ng-template>